import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { ToastService } from 'services/toast-service';
import { FloaterTypeService } from 'services/floater-type-service';
import { AsyncErrorHandler } from 'lib/ui';
import { ValidationController, ValidationControllerFactory, Validator } from 'aurelia-validation';

@autoinject
export class FloaterTypeDetail {
  private floaterType: Models.FloaterType = new Models.FloaterType();

  protected validationController: ValidationController;

  private constructor(
    private eventAggregator: EventAggregator,
    private router: Router,
    private toastService: ToastService,
    private floaterTypeService: FloaterTypeService,
    protected validator: Validator,
    validationController: ValidationControllerFactory
  ) {
    this.validationController = validationController.createForCurrentScope();
    console.log(this.validationController);
  }

  protected async activate(params: { Id: number }) {
    const floater = await this.floaterTypeService.get(params.Id);

    this.floaterType.Id = floater.Id;
    this.floaterType.Name = floater.Name;
    this.floaterType.NameEn = floater.NameEn;
    this.floaterType.NameEs = floater.NameEs;

    this.floaterType.Producer = floater.Producer;
    this.floaterType.DistanceBetweenLines = floater.DistanceBetweenLines;
    this.floaterType.NoBrackets = floater.NoBrackets;
    this.floaterType.CircumferenceOuterRing = floater.CircumferenceOuterRing;
  }

  @AsyncErrorHandler
  protected async updateFloaterType() {
    await this.floaterTypeService.put(this.floaterType, this.floaterType.Id);

    this.eventAggregator.publish('floaterTypeListReset', 1);
    this.toastService.showSuccess('floaterType.updated');
    this.router.navigateToRoute('floater-type-list');
  }

  @AsyncErrorHandler
  protected async deleteFloaterType() {
    await this.floaterTypeService.delete(this.floaterType.Id);

    this.eventAggregator.publish('floaterTypeListReset', 1);
    this.toastService.showSuccess('floaterType.deleted');
    this.router.navigateToRoute('floater-type-list');
  }

  protected gotoParentView() {
    this.eventAggregator.publish('floaterTypeListReset', 1);
    this.router.navigateToRoute('floater-type-list');
  }
}
